/** Keep aligned with `src/utils/nikonProductCodes.ts` (review notes only). */

const NIKON_US_STOREFRONT_SKU_RE = /^\d{4,8}$/;

export function isNikonBrand(brand?: string | null, brandId?: string | null): boolean {
  if (brandId && String(brandId).toLowerCase().trim() === 'nikon') return true;
  if (brand && /^nikon$/i.test(String(brand).trim())) return true;
  return false;
}

export function isNikonNumericCatalogCode(raw?: string | null): boolean {
  return NIKON_US_STOREFRONT_SKU_RE.test(String(raw || '').trim());
}

export function looksLikeNikonUrlSlugSku(sku?: string | null): boolean {
  const s = String(sku || '').trim();
  if (!s || isNikonNumericCatalogCode(s)) return false;
  return /nikkor/i.test(s) || /^[A-Z0-9]{10,}$/i.test(s);
}
